import * as Yup from "yup";

/**
 * Schema de validação Yup para Categoria Financeira.
 * Garante que o formulário só submeta dados válidos.
 */
export const financialCategorySchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome muito curto")
        .required("O nome da categoria é obrigatório"),
    type: Yup.string()
        .oneOf(["INCOME", "EXPENSE", "ASSET", "LIABILITY"], "Tipo de categoria inválido")
        .required("O tipo contábil é obrigatório"),
    parentId: Yup.string().nullable(),
    parentName: Yup.string(),
    order: Yup.number().min(0).default(0),
    isSystem: Yup.boolean().default(false),
    status: Yup.string().oneOf(["active", "inactive"]).default("active"),
});
